export default {
  name: "UploadSVG",
  props: {
    fill: {
      type: String,
      default: "#FFA621"
    }
  }
};